<div
  class="pay-by-transfer-dialog"
  [appLoading]="isLoading"
>
  <div class="pay-by-transfer-dialog__container">
    <div class="pay-by-transfer-dialog__processing-time-tip">
      <qima-icon
        [qimaIconName]="qimaIcon.iconName.TIME"
        [qimaIconSize]="qimaIcon.sizeMedium"
      ></qima-icon>
      <span>{{ 'PAY_BY_TRANSFER.PROCESSING_TIME_TIP' | translate }}</span>
    </div>

    <div class="pay-by-transfer-dialog__container__step">
      <span>{{ 'PAY_BY_TRANSFER.STEP_1' | translate }}</span>
      <qima-icon
        qimaTooltip
        [qimaTooltipPosition]="qimaTooltip.position.TOP_RIGHT"
        [qimaTooltipText]="'PAY_BY_TRANSFER.DOWNLOAD_TIP' | translate"
        [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
        [qimaTooltipHasArrow]="true"
        [qimaTooltipStyle]="qimaTooltip.style.DARK"
        [qimaIconName]="qimaIcon.iconName.DOWNLOAD_IMPORT"
        [qimaIconSize]="qimaIcon.sizeMedium"
        (click)="onPdfDownloadClick()"
      ></qima-icon>
    </div>
    <div class="pay-by-transfer-dialog__container__description qima-mb-m">{{ 'PAY_BY_TRANSFER.STEP_1_description' | translate }}</div>
    <div class="pay-by-transfer-dialog__container__payment-info">
      <div class="pay-by-transfer-dialog__container__payment-info__bank">
        @for (item of bankInfoList; track item.key) {
          <div class="app-flex app-justify-content-between qima-mt-s">
            <span class="key">{{ item.key | translate }}</span>
            <div class="value">
              <span>{{ item.value }}</span>
              @if (item.canCopy) {
                <app-clipboard
                  class="qima-ml-base"
                  [clipboardTextToCopy]="item.value"
                ></app-clipboard>
              }
            </div>
          </div>
        }
      </div>
    </div>
    <div class="pay-by-transfer-dialog__container__step qima-mt-l">
      <span>{{ 'PAY_BY_TRANSFER.STEP_2' | translate }}</span>
    </div>

    <div class="pay-by-transfer-dialog__container__description pay-by-transfer-dialog__attention-text-wrapper qima-mb-m">
      <qima-icon
        class="pay-by-transfer-dialog__attention-text-icon"
        [qimaIconName]="qimaIcon.iconName.ERROR_FILLED"
        [qimaIconSize]="qimaIcon.sizeMedium"
      ></qima-icon>

      <span class="pay-by-transfer-dialog__attention-text">{{ 'PAY_BY_TRANSFER.STEP_2_description' | translate }}</span>
    </div>

    <div class="pay-by-transfer-dialog__container__pay-item__proof__drop-file__operation">
      <qima-input-file-select
        class="upload-file-style"
        [qimaInputFileSelectLabel]="'PAY_BY_TRANSFER.UPLOAD_FILE_TIP' | translate"
        [qimaInputFileSelectIconName]="qimaIcon.iconName.ATTACHMENT"
        [qimaInputFileSelectIsMultiple]="true"
        (qimaInputFileSelectFilesChange)="onFileSelectFilesChange($event)"
        [qimaInputFileSelectAccept]="fileSelectAccept"
      ></qima-input-file-select>
    </div>
    <div
      class="pay-by-transfer-dialog__container__pay-item__proof__drop-file__tips"
      [innerHTML]="'PAY_BY_TRANSFER.UPLOAD_FILE_TIP_CONTRACT' | translate"
    ></div>
    <div
      *ngIf="uploadFiles"
      class="pay-by-transfer-dialog__container__pay-item__proof__drop-file__shows"
    >
      <div
        *ngFor="let file of uploadFiles; let idx = index; let last = last"
        appNgForTrackByUuid
        class="pay-by-transfer-dialog__container__pay-item__proof__drop-file__shows__item"
        [ngClass]="{ 'qima-mt-l': idx === 0, 'qima-mb-l': !last }"
      >
        <qima-file
          [qimaFileName]="file.name"
          [qimaFileSize]="file.size"
          [qimaFileUploadedSize]="file.size"
          [qimaFileMimeType]="qimaMimeType.APPLICATION_PDF"
          (qimaFileRemove)="onRemoveClick(file, idx)"
        >
        </qima-file>
      </div>
    </div>

    <qima-button
      class="pay-by-transfer-dialog__confirm-button qima-mt-l ga-click-submit-transfer-slip"
      [qimaButtonIsDisabled]="uploadFiles.length === 0"
      [qimaButtonLabel]="'PAY_BY_TRANSFER.SUBMIT_TRANSFER_SLIP' | translate"
      [qimaButtonIconName]="qimaIcon.iconName.SHIELD"
      [qimaButtonIconPosition]="qimaIcon.iconPosition.LEFT"
      [qimaButtonStyle]="qimaButton.buttonStyle.PRIMARY"
      [qimaButtonSize]="qimaButton.buttonSize.LARGE"
      [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
      (qimaButtonClick)="onSubmit()"
    >
    </qima-button>
  </div>
</div>
